const environment = {
    api: process.env.REACT_APP_API_URL,
    chat_api: process.env.REACT_APP_API_URL,
    userRoleId: process.env.REACT_APP_USER_ROLE_ID,
    adminRoleId: process.env.REACT_APP_ADMIN_ROLE_ID,
    subadminRoleId:process.env.REACT_APP_SUB_ADMIN_ROLE_ID,
    staffRoleId:process.env.REACT_APP_STAFF_ROLE_ID,
    managerRoleId:process.env.REACT_APP_MANAGER_ROLE_ID,
    contractorRoleId:process.env.REACT_APP_CONTRACTOR_ROLE_ID,
    supplierRoleId:process.env.REACT_APP_SUPPLIER_ROLE_ID,
    map_api_key: process.env.REACT_APP_MAP_API_KEY,
    secretKey:process.env.REACT_APP_SECRET_KEY,
  };
  
  export default environment;